import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPeriodTimes, setPeriodTimes, setPeriodShade } from "./happyschoolApi";
import { DEFAULT_END_SHADE, applyPeriodShade } from "./PeriodShadeStyle";
import { getActiveSchoolId } from "./activeSchool";

const HappySchoolPeriodTimes = () => {
  const schoolId = getActiveSchoolId();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const [shade, setShade] = useState(DEFAULT_END_SHADE);
  const [savingShade, setSavingShade] = useState(false);
  const [shadeSaved, setShadeSaved] = useState(false);

  useEffect(() => {
    if (!schoolId) return;
    setLoading(true);
    getPeriodTimes(schoolId)
      .then((data) => {
        setSessions(data.sessions);
        setShade((data.shade && data.shade.endOfSession) || DEFAULT_END_SHADE);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [schoolId]);

  if (!schoolId) {
    return (
      <div style={{ padding: 16 }}>
        Chưa chọn trường. Vào <Link to="/happyschool/schools">Trường của tôi</Link> trước.
      </div>
    );
  }

  const setTime = (sesIdx, periodIdx, value) => {
    const next = sessions.map((s, i) =>
      i === sesIdx ? { ...s, periods: s.periods.map((p, j) => (j === periodIdx ? value : p)) } : s
    );
    setSessions(next);
    setSaved(false);
  };

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      await setPeriodTimes(schoolId, sessions);
      setSaved(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const validShade = /^#[0-9a-fA-F]{6}$/.test(shade);
  const changeShade = (v) => {
    setShade(v);
    setShadeSaved(false);
    if (/^#[0-9a-fA-F]{6}$/.test(v)) applyPeriodShade(v); // xem thử ngay trên các bảng TKB, chưa lưu
  };
  const saveShade = async () => {
    if (!validShade) return;
    setSavingShade(true);
    setError("");
    try {
      await setPeriodShade(schoolId, shade);
      setShadeSaved(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSavingShade(false);
    }
  };

  return (
    <div>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Giờ đồng hồ thực tế của từng tiết — dùng để hiện trên bảng thời khoá biểu. Số buổi/số tiết mỗi buổi ở đây
        cũng quyết định luôn cấu trúc mà thuật toán xếp lịch dùng.
      </p>
      {error && <p style={{ color: "#dc2626" }}>{error}</p>}
      {loading ? (
        <p>Đang tải...</p>
      ) : (
        <>
          <table style={{ borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>Buổi</th>
                <th style={thStyle}>Tiết</th>
                <th style={thStyle}>Giờ</th>
              </tr>
            </thead>
            <tbody>
              {sessions.map((ses, sesIdx) =>
                ses.periods.map((time, periodIdx) => (
                  <tr key={`${ses.key}-${periodIdx}`}>
                    {periodIdx === 0 && (
                      <td style={tdStyle} rowSpan={ses.periods.length}>
                        <strong>{ses.label}</strong>
                      </td>
                    )}
                    <td style={tdStyle}>{periodIdx + 1}</td>
                    <td style={tdStyle}>
                      <input
                        value={time}
                        onChange={(e) => setTime(sesIdx, periodIdx, e.target.value)}
                        style={{ padding: 4, width: 140 }}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <button onClick={save} disabled={saving} style={btnStyle}>
            {saving ? "Đang lưu..." : "Lưu"}
          </button>
          {saved && <span style={{ marginLeft: 8, color: "#0ea5a3", fontSize: 13 }}>Đã lưu.</span>}

          <h4 style={{ margin: "24px 0 4px" }}>Màu nền buổi chiều (tiết 6–10)</h4>
          <p style={{ color: "#6b7280", fontSize: 13, margin: "0 0 8px" }}>
            Áp dụng cho các bảng thời khoá biểu (theo lớp, theo giáo viên, tất cả lớp, tất cả giáo viên). Chỉ đổi ô đang có tiết; ô trống để trắng, ô Bận giữ màu đỏ, buổi sáng (tiết 1–5) giữ nguyên.
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <input type="color" value={validShade ? shade : DEFAULT_END_SHADE} onChange={(e) => changeShade(e.target.value.toUpperCase())} style={{ width: 44, height: 32, padding: 0, border: "1px solid #d1d5db", borderRadius: 4 }} />
            <input
              value={shade}
              onChange={(e) => changeShade(e.target.value.trim().toUpperCase())}
              placeholder="#CCFFFF"
              maxLength={7}
              style={{ padding: 4, width: 90, fontFamily: "monospace", borderColor: validShade ? undefined : "#dc2626" }}
            />
            <button type="button" onClick={() => changeShade(DEFAULT_END_SHADE)} style={{ ...btnStyle, marginTop: 0, background: "#6b7280" }}>Mặc định</button>
            <button type="button" onClick={saveShade} disabled={savingShade || !validShade} style={{ ...btnStyle, marginTop: 0 }}>
              {savingShade ? "Đang lưu..." : "Lưu màu"}
            </button>
            {shadeSaved && <span style={{ color: "#0ea5a3", fontSize: 13 }}>Đã lưu.</span>}
            {!validShade && <span style={{ color: "#dc2626", fontSize: 13 }}>Mã màu dạng #RRGGBB</span>}
          </div>
        </>
      )}
    </div>
  );
};

const thStyle = { border: "1px solid #e5e7eb", padding: "6px 10px", background: "#f9fafb" };
const tdStyle = { border: "1px solid #e5e7eb", padding: "6px 10px" };
const btnStyle = { marginTop: 12, padding: "8px 16px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600 };

export default HappySchoolPeriodTimes;
